import { render, staticRenderFns } from "./our-team.vue?vue&type=template&id=36618c7c&scoped=true"
import script from "./our-team.vue?vue&type=script&lang=js"
export * from "./our-team.vue?vue&type=script&lang=js"
import style0 from "./our-team.vue?vue&type=style&index=0&id=36618c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36618c7c",
  null
  
)

export default component.exports